import axiosBaseApi from '@/services/common/lib/axiosBaseApi';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { FETCH_LEADERBOARD, LEADERBOARD_TIMEOUT } from './leaderboardActions';
import { getLeaderboard } from './leaderboard.service';
import { handleLeaderboardTimeout } from './leaderboardReducer';

export const fetchLeaderboardThunk = createAsyncThunk(FETCH_LEADERBOARD, async () => {
  const response = await axiosBaseApi.get<any>(`/v1/leaderboard/`);
  return response.data;
});

export const handleLeaderboardTimeoutThunk = createAsyncThunk(
  LEADERBOARD_TIMEOUT,
  async (_, { getState, dispatch }) => {
    const state = getState() as any;
    const selectedLeaderboard = state.leaderboard.selectedLeaderboard;

    const nextLeaderboardPoller = setInterval(async () => {
      const nextLeaderboard = await getLeaderboard();

      if (nextLeaderboard?.leaderboard?.id !== selectedLeaderboard?.id) {
        clearInterval(nextLeaderboardPoller);
        dispatch(
          handleLeaderboardTimeout({
            currentLeaderboard: selectedLeaderboard,
            nextLeaderboard,
          }),
        );
      }
    }, 2000);
  },
);
